import { useEffect, useState } from 'react';
import axios from 'axios';
import './ManageNotifications.css';


export default function NotificationHistory({ refresh, onEdit }) {
  const [notifications, setNotifications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 10;

  useEffect(() => {
    fetchNotifications();
  }, [refresh]);

  const fetchNotifications = async () => {
    const res = await axios.get(
      'https://spinelleapi.emedha.in/admin/advertise/api/notifications'
    );
    setNotifications(res.data);
  };

  const deleteNotification = async (id) => {
    if (!window.confirm('Are you sure?')) return;

    await axios.delete(
      `https://spinelleapi.emedha.in/admin/advertise/api/notifications/${id}`
    );
    fetchNotifications();
  };

  // Pagination
  const start = (currentPage - 1) * perPage;
  const current = notifications.slice(start, start + perPage);
  const pages = Math.ceil(notifications.length / perPage);

  return (
    <>
      <h3>Notifications History</h3>

      <table className="category-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Image</th>
            <th>URL</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {current.map((n, i) => (
            <tr key={n.id}>
              <td>{start + i + 1}</td>
              <td>{n.title}</td>
              <td>
                {n.image && <img src={n.image} alt="" width="60" />}
              </td>
              <td>{n.url}</td>
              <td>
                {/* <button className="edit-btn" onClick={() => onEdit(n)}>
                  Edit
                </button> */}
                <button
                  className="delete-btn"
                  onClick={() => deleteNotification(n.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        {[...Array(pages)].map((_, i) => (
          <button
            key={i}
            className={currentPage === i + 1 ? 'active' : ''}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </>
  );
}
